'use client';

import React, { useState } from 'react';

type TenantGalleryMosaicProps = {
  images: Array<{ src: string; alt: string; caption?: string; index?: number }>;
  selectedIndex?: number;
};

const COLLAPSED_VISIBLE_IMAGES = 6;

const TenantGalleryMosaic: React.FC<TenantGalleryMosaicProps> = ({ images, selectedIndex }) => {
  const [expanded, setExpanded] = useState(false);
  const hasMoreImages = images.length > COLLAPSED_VISIBLE_IMAGES;
  const collapsed = hasMoreImages && !expanded;

  return (
    <>
      <div className={collapsed ? 'gallery-frame collapsed' : 'gallery-frame'}>
        <div className="gallery-masonry">
          {images.map((image, index) => (
            <figure
              key={image.src + String(index)}
              data-gallery-index={image.index ?? index}
              className={selectedIndex === (image.index ?? index) ? 'gallery-item-selected' : undefined}
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
              {image.caption ? <figcaption>{image.caption}</figcaption> : null}
            </figure>
          ))}
        </div>
        {collapsed ? (
          <div className="gallery-fade">
            <button type="button" onClick={() => setExpanded(true)}>Show More Photos</button>
          </div>
        ) : null}
      </div>
      {expanded && hasMoreImages ? (
        <button className="gallery-collapse" type="button" onClick={() => setExpanded(false)}>
          Show Fewer Photos
        </button>
      ) : null}
    </>
  );
};

export default TenantGalleryMosaic;
